import React from 'react';

class NotFound extends React.Component {
  render() {
    return <h2>Page not found!</h2>;
  }
}

export default NotFound;